// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"ea65495a","619":"306f3909"}[chunkId] + ".chunk.js";
};